import React from 'react';
import { flowRight } from 'lodash';
import { type WithTranslation } from '@wix/yoshi-flow-editor';
import withLayoutColorClasses, {
  type WithLayoutColorClasses,
} from '../../hoc/with-layout-color-classes';
import withTranslate from '../../hoc/with-translate';
import { CounterCompact } from '../counter-compact';
import { ViewCountIcon } from '../icons/view-count-icon';

type Props = React.ComponentProps<typeof CounterCompact> &
  WithLayoutColorClasses &
  Pick<WithTranslation, 't'>;

const ViewCountCompact = ({ t, iconColorClassName, ...counterProps }: Props) => (
  <CounterCompact {...counterProps} dataHook="view-count-compact" ariaHidden={true}>
    <ViewCountIcon
      aria-label={t('view-count.label', {
        count: counterProps.count,
        numberFormatted: counterProps.countFormatted,
      })}
      className={iconColorClassName}
    />
  </CounterCompact>
);

export default flowRight(withTranslate, withLayoutColorClasses)(ViewCountCompact);
